import { ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import html2canvas from 'html2canvas';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { Subscription } from 'rxjs';
import { SettingService } from '../../../business-services/setting.service';
import { ServiceCategory } from './../../../business-entities/service-category.interface';
import { ServiceCategoryDetails } from './../../../business-entities/service-details.interface';
import { Service } from './../../../business-entities/service.interface';
import { SelectService } from './../../../business-services/select-service.service';
import { CommonService } from './../../../services/commom.service';
import * as Enums from './../../../utils/enums';
import { WidgetCustomerVehicleDetails } from '../../../business-entities/widget-customer-vehicle-details-model';
import { ServiceFilterModel } from '../../../business-entities/service-filter-model';
import { Utility } from '../../../../../../Autofacets-Core/src/app/utils/utility';
import { Features } from '../../../business-entities/step.class';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import * as CommonEnum from 'projects/Autofacets-Core/src/app/utils/enums';
import { FormBuilder } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UploadDocumentComponent } from '../../../../../../Autofacets-Core/src/app/views/UploadDocument/upload-document/upload-document.component';
import { isNullOrUndefined } from '@swimlane/ngx-datatable';

interface ServiceSectionDetails {
  selectedService: Service[];
  carCode: string | null;
  mileage: number | null;
  stoneChipInput: string | null;
  bodyBrokenIconPositions: { left: number; top: number }[] | null;
  damageIconImage: string | null;
  otherIssuesInput: string;
  damageDescription: string | null;
}

@Component({
  selector: 'app-select-services',
  templateUrl: 'select-services.component.html'
})
export class SelectServicesComponent implements OnInit, OnDestroy {

  selectedServices: Service[] = [];
  serviceCategories: ServiceCategory[] = [];
  serviceList: Service[] = [];
  serviceDetails: ServiceCategoryDetails[]=[];
  selectedServiceIndex = 0;
  displayDescribeIssueInput = false;
  displayServiceSection = false;
  displayBodyRepairSection = false;
  displayStoneChipIssueInput = false;
  code: string;
  mileage: number;
  isCode = true;
  damageIcons: { top: number, left: number }[] = [];
  stoneChipIssue: string;
  otherIssue: string;
  damageDescription: string;
  base64Image: string;
  isDirty = false;
  isMileageError: boolean = false;
  currentlagSub: Subscription
  currentlanguage:string;
  selectedCustomerVehicleDetails:WidgetCustomerVehicleDetails;
  serviceFilterModel:ServiceFilterModel;
  isShowService:boolean = false;
  allWarningLight:any[]=[];
  selectedWarningLight:string='';
  features: Features[] = [];
  isWarningLightFeature: boolean =false;
  @Output() openAnotherPanelRequest = new EventEmitter<string>();
  UploadDocumentService:Service;
  allowCustomerToUploadDoc:boolean = false;
  isWCVLS: boolean = false;//Widget - Customer Verification at last step
  isWSSBLP: boolean = false;//Widget - Step-1 Search by license plate
  constructor(
    private ssService: SelectService,
    private commonService: CommonService,
    private spinner: NgxSpinnerService,
    private cdr: ChangeDetectorRef,
    public settingService: SettingService,
    private currentLanguageService: CurrentLanguage,
    private toastr: ToastrService,
    private translate: TranslateService,
    private secureStorage: SecureStorage,
    public fb: FormBuilder,
    
    private modalService: NgbModal,
    public toaster: ToastrService,
  ) { }
  ngOnDestroy(): void {
    this.currentlagSub.unsubscribe();
  }

  ngOnInit(): void {
    if (this.secureStorage.getKeyData('feature')) {
      this.features = this.secureStorage.getKeyData('feature');
      if(this.features.find(x => x.featureCode === CommonEnum.FeatureCode.WarningLight))
      this.isWarningLightFeature=this.features.find(x => x.featureCode === CommonEnum.FeatureCode.WarningLight)?.isActive;
      this.allowCustomerToUploadDoc=this.features.find(x => x.featureCode === CommonEnum.FeatureCode.AllowCustomerUploadDoc)?.isActive;
    }  
    if(this.commonService.allWarningLight && this.isWarningLightFeature)
    {
      this.allWarningLight=this.commonService.allWarningLight
    }
    if(this.features.find(x=>x.featureCode===CommonEnum.FeatureCode.WSSBLP))
    {
      this.isWSSBLP =this.features.find(x => x.featureCode === CommonEnum.FeatureCode.WSSBLP)?.isActive;
    }
   
    this.selectedCustomerVehicleDetails = this.commonService.getSelectedCustomerVehicleDetails();
    this.initialize();
  }
  initialize(): void {
    this.spinner.show();
    this.currentlagSub = this.currentLanguageService.currentLanguage.subscribe(x => {
      this.currentlanguage = x;
      const appData = this.commonService.getAppData();
      if (appData.currentLanguage === x && appData.selectedService && appData.selectedService.length > 0) {
        this.isShowService = true;
        this.initializeVariables();
      }
      else {
        this.mileage = (this.selectedCustomerVehicleDetails?.previousKilometer)?this.selectedCustomerVehicleDetails?.previousKilometer:null;
      }
    });
    this.spinner.hide()
  }
  async ShowServices(){
    this.selectedServiceIndex = 0;
    this.isShowService = true;
    this.selectedServices=[];
    if(this.isWarningLightFeature)
    {
      await this.GetWarningLight();
    }
    this.currentLanguageService.currentLanguage.subscribe((res)=>{
    this.GetSelectServiceSectionDetails(this.currentlanguage); 
    })
    
  }

  async GetWarningLight() {
    await this.ssService.getWarningLightDropDown(this.currentlanguage)
      .then((response) => {
        this.allWarningLight = response;
        this.commonService.allWarningLight=this.allWarningLight;
      });
  }

  OpenModel(content,service){
    this.UploadDocumentService = service;
    const modalref = this.modalService.open(UploadDocumentComponent, { size: 'lg' });
    modalref.componentInstance.uniqueId = service?.id;
    modalref.result.then((response) => {
    }, _error => { 
     
    });
  }

  

  GetSelectServiceSectionDetails(language) {
    let selectedCustomerVehicle = this.commonService.getSelectedCustomerVehicleDetails();
    let dateFormatRegistrationDate = Utility.getDateStringToDate(Utility.GetFormattedDate(selectedCustomerVehicle.registrationDate));
    let date = new Date();
    let vehicleAge = Utility.monthDiff(dateFormatRegistrationDate, date);
    let mileage = this.mileage;
    if (mileage == null) {
      mileage = selectedCustomerVehicle.previousKilometer == null ? 0 : selectedCustomerVehicle.previousKilometer;
    }
    this.serviceFilterModel = {
      fuelType: selectedCustomerVehicle.fuelType,
      vehicleType: selectedCustomerVehicle.vehicleType,
      brand: selectedCustomerVehicle.companyMakeCode,
      model: selectedCustomerVehicle.companyModel,
      language: language,
      mileage: mileage,
      vehicleAge: vehicleAge
    };
    this.ssService.GetSelectServiceSectionDetails(this.serviceFilterModel)
      .then((result) => {
        if (result.responseObject) {
          const appData = this.commonService.getAppData();
          this.serviceDetails = result.responseObject as ServiceCategoryDetails[];
          this.commonService.addServiceAndCategoryDetails(this.serviceDetails, this.currentlanguage);
          this.serviceCategories = []
          this.serviceDetails.forEach(element => {
            element.selectedWarningLight = ''
            if (element.childServiceId) {
              element.childServiceIdArray = element.childServiceId.split(',')
            }
            const categoryId = element.serviceCategoryId
            let isExist = this.serviceCategories.find(x => x.id === categoryId)
            if (isExist === null || isExist === undefined)
            //if (isNullOrUndefined(isExist)) 
            {
              const model = {
                id: element.serviceCategoryId,
                service: element.serviceCategoryName,
                orderNumber: element.serviceCategoryOrderNumber
              }
              this.serviceCategories.push(model);
            }
            let warrantyLightList;
            //for warrenty light
            if (element.isWarningLight && this.isWarningLightFeature) {
              warrantyLightList = element.warningLightId.split(',');
              element.warningLightIdList = [];

              this.allWarningLight.forEach(warrentyLight => {
                warrantyLightList.forEach(associatedWarrentyLight => {
                  if (warrentyLight.id.toString() === associatedWarrentyLight) {
                    const warrentyLightModel =
                    {
                      Id: warrentyLight.id,
                      Image: warrentyLight.logo,
                      WarningNameName: warrentyLight.warningName,
                      IsSelected: false
                    }
                    element.warningLightIdList.push(warrentyLightModel);
                  }
                });
              });
            }

          });
          const sortedServiceCategories = this.serviceCategories.sort((a, b) =>
            ((a.orderNumber != null ? a.orderNumber : Infinity) - (b.orderNumber != null ? b.orderNumber : Infinity))
          );
          this.serviceCategories = sortedServiceCategories;

          if (appData.selectedService && appData.selectedService.length > 0) {
            this.serviceDetails.forEach((service) => {
              const selectService = this.selectedServices.find(s => s.id === service.id)
              if (!isNullOrUndefined(selectService)) { 
                this.selectedServices.find(s => s.id === service.id).name = service.name 
              }
            })
          }
          this.serviceList = this.serviceDetails.filter(x => x.serviceCategoryId === this.serviceCategories[0].id);
          const sortedServiceList = this.serviceList.sort((a, b) =>
            (a.orderNumber != null ? a.orderNumber : Infinity) - (b.orderNumber != null ? b.orderNumber : Infinity)
          );

          this.serviceList = sortedServiceList;

        }
        this.cdr.detectChanges();
        this.spinner.hide();
      });
  }

  onSelectWarningLight(warningLight:any,service:any)
  {
    warningLight.isSelected=!warningLight.isSelected;
    let result = service.selectedWarningLight.includes(warningLight.Id);
    if(!result)
    {
      service.selectedWarningLight+= warningLight.Id + ',';
    }
  }

  initializeVariables() {
    const appData = this.commonService.getAppData();
    this.isDirty = true;
    this.serviceDetails = appData.serviceAndCategoryDetails;
    this.selectedServices = appData.selectedService;
    this.serviceDetails.forEach((service) => {
      const selectService = this.selectedServices.find(s => s.id === service.id)
      if (!isNullOrUndefined(selectService)) {
        this.selectedServices.find(s => s.id === service.id).name = service.name
      }
    })
    this.serviceDetails.forEach(element => {
      const categoryId = element.serviceCategoryId
      let isExist = this.serviceCategories.find(x => x.id === categoryId)
      if(isExist === null || isExist === undefined)
      //if (isNullOrUndefined(isExist)) 
      {
        const model = {
          id: element.serviceCategoryId,
          service: element.serviceCategoryName,
          orderNumber:element.serviceCategoryOrderNumber
        }
        this.serviceCategories.push(model);
        const sortedServiceCategories = this.serviceCategories.slice().sort((a, b) =>
                          (a.orderNumber != null ? a.orderNumber : Infinity) - (b.orderNumber != null ? b.orderNumber : Infinity)
                        );

      this.serviceCategories = sortedServiceCategories;

      }
    });
    this.serviceList = this.serviceDetails.filter(x => x.serviceCategoryId === this.serviceCategories[0].id);
    const sortedServiceList = this.serviceList.slice().sort((a, b) =>
                        (a.orderNumber != null ? a.orderNumber : Infinity) - (b.orderNumber != null ? b.orderNumber : Infinity)
                      );

    this.serviceList = sortedServiceList;

    this.code = appData.carCode;
    this.mileage = appData.mileage;
    this.damageIcons = appData.bodyBrokenIconPositions ? appData.bodyBrokenIconPositions : [];
    this.stoneChipIssue = appData.stoneChipInput;
    this.otherIssue = appData.otherIssuesInput;
    this.damageDescription = appData.damageDescription;
  }

  changeCategory(index: number): void {
    this.selectedServiceIndex = index;
    const category = this.serviceCategories[index];
    this.serviceList = this.serviceDetails.filter(x => x.serviceCategoryId === category.id);
    const sortedServiceList = this.serviceList.slice().sort((a, b) =>
                        (a.orderNumber != null ? a.orderNumber : Infinity) - (b.orderNumber != null ? b.orderNumber : Infinity)
                      );

    this.serviceList = sortedServiceList;
    this.toggleServiceSections(category.id);
  }

  toggleServiceSections(selectedCategoryId: number) {
    this.checkForDescribeInput(selectedCategoryId);
    this.checkForServiceSection(selectedCategoryId);
    this.checkForBodyRepairSection(selectedCategoryId);
    this.checkForStoneChipIssue(selectedCategoryId);
  }

  checkForDescribeInput(categoryId: number): void {
    if (categoryId === Enums.ServiceCategoryIds.OtherComplainId) {
      this.displayDescribeIssueInput = true;
    } else {
      this.displayDescribeIssueInput = false;
    }
  }

  checkForStoneChipIssue(categoryId: number): void {
    if (categoryId === Enums.ServiceCategoryIds.GlassId &&
      this.selectedServices.findIndex(x => x.id === Enums.ServiceIds.StoneChip) !== -1) {
      this.displayStoneChipIssueInput = true;
    } else {
      this.displayStoneChipIssueInput = false;
    }
  }

  checkForServiceSection(categoryId: number): void {
    if (categoryId === Enums.ServiceCategoryIds.ServicesId &&
      this.selectedServices.findIndex(x => x.id === Enums.ServiceIds.ServiceId) !== -1) {
      this.displayServiceSection = true;
    } else {
      this.displayServiceSection = false;
    }
  }

  checkForBodyRepairSection(categoryId: number): void {
    if (categoryId === Enums.ServiceCategoryIds.BodyWorkId &&
      this.selectedServices.findIndex(x => x.id === Enums.ServiceIds.BodyRepair) !== -1) {
      this.displayBodyRepairSection = true;
    } else {
      this.displayBodyRepairSection = false;
    }
  }


  selectService(service: Service,event): void {
      if(service.addedAsChildService && event.target.checked ===false)
      {
        event.preventDefault();
      }

    this.isDirty = true;
    const index = this.selectedServices.findIndex(x => x.id === service.id)
    if (index === -1) {
      this.selectedServices.push(service);
      //add to servicelist to display in html
      this.serviceList.forEach(element => {
         if(element.childServiceId)
            {
              element.displaychildServiceDetail=[];
              element.childServiceIdArray.forEach(id => {
                let details=this.serviceDetails.filter(x=>x.id===parseInt(id))[0];
                if(details)
                {
                  if ( element.displaychildServiceDetail.find((test) => test.id === details.id) === undefined) {
                  element.displaychildServiceDetail.push(details)
                }
              }
              });
             
            }
      });
      //if child service exists 
      if(service.childServiceIdArray?.length>0)
      {
          let childServiceName='';
          let childArray = service.childServiceIdArray.filter((value,index,self) => self.indexOf(value) === index)
          childArray.forEach(element => {
            //check child service already selected?
            let selectedChildService=this.selectedServices.filter(x=>x.id===parseInt(element))[0];
            //if child service already selected (already added to selected service)
            if(selectedChildService)
            {
              //update value in selected service array
              selectedChildService.addedAsChildService=true;
              selectedChildService.parentServiceName=service.name;
              selectedChildService.parentServiceId=service.id;
              childServiceName = childServiceName+selectedChildService.name
            }            
          });
      }
      if (service.serviceCategoryId === Enums.ServiceCategoryIds.ServicesId && service.id === Enums.ServiceIds.ServiceId) {
        this.displayServiceSection = true;
      }
      if (service.serviceCategoryId === Enums.ServiceCategoryIds.BodyWorkId && service.id === Enums.ServiceIds.BodyRepair) {
        this.displayBodyRepairSection = true;
      }
      if (service.serviceCategoryId === Enums.ServiceCategoryIds.GlassId && service.id === Enums.ServiceIds.StoneChip) {
        this.displayStoneChipIssueInput = true;
      }
    }
    else {
      this.removeService(index,service);
    }
  }

  checkMileage() {
    this.isShowService = false;
    if(this.mileage != null){
      if (this.mileage && (this.mileage.toString().length < 1 || this.mileage.toString().length > 8)) {
        this.isMileageError = true;
      }
      else {
        let regexp = new RegExp('^[0-9]{0,8}$');
        let testMileage = regexp.test(this.mileage.toString());
        this.isMileageError= testMileage ? false: true;
      }
    }else{
      this.isMileageError = false;
    }
  }

  checkIfServiceSelected(service: Service): boolean {
    return this.selectedServices.findIndex(x => x.id === service.id) !== -1;
  }

  async onBodyRepairClick(event: any): Promise<void> {
    const imageHtml: any = document.getElementById('bodyDamageImage');
    const posX = imageHtml.x;
    const posY = imageHtml.y;
    const Xpos = event.clientX - posX;
    const Ypos = event.clientY - posY;
    this.damageIcons.push({ left: Xpos - 10, top: Ypos - 10 });
    await this.mergeImg();
  }

  removeIcon(index: number): void {
    this.damageIcons.splice(index, 1);
  }

  removeService(index: number,service:Service): void {
    if (this.selectedServices[index].id === Enums.ServiceIds.ServiceId) {
      this.displayServiceSection = false;
    }
    if (this.selectedServices[index].id === Enums.ServiceIds.BodyRepair) {
      this.displayBodyRepairSection = false;
    }
    if (this.selectedServices[index].id === Enums.ServiceIds.StoneChip) {
      this.displayStoneChipIssueInput = false;
    }
    //if parent remove than remove child first
    if(this.selectedServices[index]?.childServiceIdArray?.length>0)
    {
      this.selectedServices[index]?.childServiceIdArray.forEach(()=>{
        this.selectedServices.forEach((element ,childIndex)=> {
          if(element.addedAsChildService && element.parentServiceId===(this.selectedServices[index]?.id))
          {
            //remove child
            element.addedAsChildService=false;
            this.selectedServices.splice(childIndex, 1);
          }
        });
      })
      //remove from list for display in html
      this.serviceList.forEach(element => {
        if(element.childServiceId && element.id===service.id){
             element.displaychildServiceDetail=[];
           }
     });
    }
    let removeIndex=this.selectedServices.findIndex(x=>x.id===service.id)
    this.selectedServices.splice(removeIndex, 1);
    let localDocs = this.commonService.getDocument(service.id)
    if(localDocs && localDocs?.length>0){
      this.commonService.removeDocument(service.id)
    }
  }

  SelectChildService(childservice : Service){
    let removeIndex=this.selectedServices.findIndex(x=>x.id===childservice.id)
    if(removeIndex >= 0){
      this.selectedServices.splice(removeIndex, 1);
    }
    else{
      this.selectedServices.push(childservice);
    }
  }

  onChangeCommentService(service){
    let exists = this.selectedServices.find(x=>x.id == service.id)
    if (exists) {
      exists.additionalCustomerComment = service.additionalCustomerComment;
    }
  }
  completeStep(): void {
    if (this.selectedServices.length === 0) {
      this.isDirty = true;
      return;
    }
    if(this.mileage==null)
    {
      this.mileage = this.selectedCustomerVehicleDetails.previousKilometer;
    }
    const isBodyRepairSelected = this.selectedServices.findIndex(x => x.id === Enums.ServiceIds.BodyRepair) !== -1;
    const isStoneChipSelected = this.selectedServices.findIndex(x => x.id === Enums.ServiceIds.StoneChip) !== -1;
    const isMaintainanceServiceSelected = this.selectedServices.findIndex(x => x.id === Enums.ServiceIds.ServiceId) !== -1;
    const details: ServiceSectionDetails = {
      selectedService: this.selectedServices,
      carCode: isMaintainanceServiceSelected ? this.code : null,
      mileage: this.mileage ? this.mileage : null,
      stoneChipInput: isStoneChipSelected ? this.stoneChipIssue : null,
      bodyBrokenIconPositions: isBodyRepairSelected ? this.damageIcons : null,
      damageIconImage: isBodyRepairSelected ? this.base64Image : null,
      otherIssuesInput: this.otherIssue,
      damageDescription: isBodyRepairSelected ? this.damageDescription : null
    };
    this.commonService.addSelectServiceSectionDetails(details);
    this.commonService.completePanel(Enums.PanelIds.Panel2);
    this.openAnotherPanelRequest.emit(Enums.PanelIds.Panel3);
  }

  async mergeImg(): Promise<void> {
    if (this.damageIcons.length > 0) {
      this.cdr.detectChanges();
      const data = document.getElementById('bodyrepair');
      if (data) {
        await html2canvas(data,
          { logging: false }
        ).then(canvas => {
          this.base64Image = canvas.toDataURL('image/png');
        });
      }
    }
  }

  goToPrevious(): void {
    this.openAnotherPanelRequest.emit(Enums.PanelIds.Panel1);
  }
}
